import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const DAYS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const PickField = ({ id, label, value, onChange, placeholder, items }) => (
  <div className="space-y-2">
    <Label htmlFor={id}>{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id={id} data-testid={`${id}-select`}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {items.map((it) => (
          <SelectItem key={it.value} value={it.value}>{it.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const TimetableSlotFields = ({ form, setForm, classes, subjects, teachers, prefix }) => {
  const set = (key) => (value) => setForm({ ...form, [key]: value });
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <PickField id={`${prefix}-class`} label="Classe *" value={form.class_id} onChange={set('class_id')} placeholder="Choisir la classe"
          items={classes.map((c) => ({ value: c.id, label: c.name }))} />
        <PickField id={`${prefix}-subject`} label="Matière *" value={form.subject_id} onChange={set('subject_id')} placeholder="Choisir la matière"
          items={subjects.map((s) => ({ value: s.id, label: `${s.name} (${s.code})` }))} />
      </div>
      <PickField id={`${prefix}-teacher`} label="Enseignant *" value={form.teacher_id} onChange={set('teacher_id')} placeholder="Choisir l'enseignant"
        items={teachers.map((t) => ({ value: t.id, label: `${t.first_name} ${t.last_name}` }))} />
      <PickField id={`${prefix}-day`} label="Jour de la semaine *" value={String(form.day_of_week)} onChange={(v) => setForm({ ...form, day_of_week: parseInt(v, 10) })}
        placeholder="Choisir le jour" items={DAYS.map((d, i) => ({ value: String(i), label: d }))} />
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor={`${prefix}-start`}>Heure de début *</Label>
          <Input id={`${prefix}-start`} data-testid={`${prefix}-start-input`} type="time" value={form.start_time} required
            onChange={(e) => setForm({ ...form, start_time: e.target.value })} />
        </div>
        <div className="space-y-2">
          <Label htmlFor={`${prefix}-end`}>Heure de fin *</Label>
          <Input id={`${prefix}-end`} data-testid={`${prefix}-end-input`} type="time" value={form.end_time} required
            onChange={(e) => setForm({ ...form, end_time: e.target.value })} />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${prefix}-room`}>Salle</Label>
        <Input id={`${prefix}-room`} data-testid={`${prefix}-room-input`} value={form.room} placeholder="Ex: A101, Laboratoire, Gymnase"
          onChange={(e) => setForm({ ...form, room: e.target.value })} />
      </div>
    </>
  );
};
